import React from 'react';
import { Container } from 'react-bootstrap';

const Encuentranos = () => {
  return (
    <section id="encuentranos" className="encuentranos-section" style={{ padding: '5rem 0', backgroundColor: 'var(--bg-dark, #121212)', color: 'var(--text-light, #ffffff)' }}>
      <Container style={{ textAlign: 'center' }}>
        <h2 className="cormorant-garamond menu-main-title" style={{ marginBottom: '1rem', color: 'var(--accent-gold, #d4af37)' }}>
          Encuéntranos
        </h2>
        <p className="menu-subtitle" style={{ marginBottom: '0.5rem', fontSize: '1.2rem' }}>
          Av. Ricardo Rivera Navarrete 2761, Lince.
        </p>
        <p className="menu-subtitle" style={{ marginBottom: '2.5rem', fontSize: '1.1rem', color: 'var(--text-secondary, #b3b3b3)' }}>
          Teléfonos: +51 948156106 / 01 2081812
        </p>
        
        <div className="map-responsive" style={{ overflow: 'hidden', paddingBottom: '45%', position: 'relative', height: 0, borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)', marginBottom: '2rem' }}>
          <iframe 
            src="https://maps.google.com/maps?q=Deli+Rous,+Av.+Ricardo+Rivera+Navarrete+2761,+Lince&t=&z=16&ie=UTF8&iwloc=&output=embed" 
            width="100%" 
            height="100%" 
            style={{ border: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="DeliRous Restaurant Location"
          ></iframe>
        </div>

        <a 
          href="https://maps.app.goo.gl/fSEhUJrxBMDJSezu6" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-primary"
          style={{
            backgroundColor: 'var(--accent-gold, #d4af37)',
            borderColor: 'var(--accent-gold, #d4af37)',
            color: '#000',
            fontWeight: 'bold',
            padding: '10px 30px',
            borderRadius: '30px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textDecoration: 'none',
            display: 'inline-block'
          }}
        >
          Ver en Google Maps
        </a>
      </Container>
    </section>
  );
};

export default Encuentranos;
